import { __decorate } from "tslib";
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import HelixElement from '../../shared/types/helix-element.js';
import { SlotController } from '../../shared/controllers/slot.controller.js';
import { localized } from '@lit/localize';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { cardStyles } from './card.styles.js';
let HlxCard = class HlxCard extends HelixElement {
    constructor() {
        super(...arguments);
        this.slotController = new SlotController(this, 'image', 'header', 'footer');
    }
    render() {
        return html `
            <div
                part="base"
                class=${classMap({
            'hlx-card': true,
            'hlx-card-has-image': this.slotController.hasSlot('image'),
            'hlx-card-has-header': this.slotController.hasSlot('header'),
            'hlx-card-has-footer': this.slotController.hasSlot('footer'),
        })}>
                <slot name="image" part="image" class="hlx-card-image"></slot>
                <slot name="header" part="header" class="hlx-card-header"></slot>
                <slot part="body" class="hlx-card-body"></slot>
                <slot name="footer" part="footer" class="hlx-card-footer"></slot>
            </div>
        `;
    }
};
HlxCard.styles = [componentStyles, cardStyles];
HlxCard = __decorate([
    customElement('hlx-card'),
    localized()
], HlxCard);
export { HlxCard };
//# sourceMappingURL=card.js.map